<template>
  <v-container>
    <v-card flat>
      <v-card-title>
        <v-btn
          color="warning"
          class="mr-4"
          dark
          @click="$htmlToPaper('reportList')"
          >IMPRIMIR</v-btn
        >
      </v-card-title>
      <v-card-text>
        <div v-if="loader">CARREGANDO...</div>
        <Report
          :data="dataReport"
          :filter="filter"
          :prefecture="prefecture"
          ref="allComponent"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Report from "./report";
export default {
  components: { Report },
  props: {
    endDate: null,
    startDate: null,
    provider_id: null,
    prefecture_id: null,
    vehicle_id: null,
  },
  data: () => ({
    dataReport: [],
    filter: {},
    prefecture: [],
    provider: [],
    loader: false,
  }),
  created() {
    this.loadReport();
  },
  methods: {
    loadReport() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      (this.filter = {
        endDate: this.endDate,
        startDate: this.startDate,
        prefecture_id: this.prefecture_id,
        provider_id: this.provider_id,
      }),
        this.$http
          .get(`/prefectures/${this.filter.prefecture_id}`)
          .then((p) => {
            this.prefecture = p.data[0];
          });
      this.$http.post(`/billings/nfes/report`, this.filter).then((r) => {
        this.dataReport = r.data;
        this.loader = false;
        this.$store.dispatch("setLoader", this.loader);
      });
    },
  },
};
</script>

<style>
</style>